import dayjs from '@app/js/lib/dayjs';
import Vue from 'vue'
import {getZhDay} from '../util/function'

Vue.filter('time', function(value) {
    if(value == ""){
      return ""
    }
    return dayjs.unix(value).format('YYYY年MM月DD日');
});

Vue.filter('time2', function(value) {
    if(value == ""){
      return ""
    }
    return dayjs.unix(value).format('YYYY-MM-DD');
});

Vue.filter('time3', function (value) {
  if (value == "") {
    return ""
  }
  return dayjs.unix(value).format('YYYY.MM.DD');
});

Vue.filter('time-minute', function(value) {
  if(value == ""){
    return ""
  }
  const day = dayjs.unix(value).format('d')
  return getZhDay(day) + " " + dayjs.unix(value).format('YYYY-MM-DD HH:mm');
})

Vue.filter('time-second', function(value) {
  if(value == ""){
    return ""
  }
  return dayjs.unix(value).format('YYYY-MM-DD HH:mm:ss');
})


